import { connect } from 'react-redux';

import { requestReset } from '../actions/subscriptions';
import ResetButtonView from '../components/ResetButtonView';

class ResetButton extends ResetButtonView {}

export default connect(
  null,
  { resetSubscriptions: requestReset }
)(ResetButton);
